// extracted by mini-css-extract-plugin
export default {"chartWrapper":"WizardChart_chartWrapper__KVLuR"};